import { Typography } from '@mui/material';

const watchlistTableHeaders = [
    {
        id: 'invoice_id',
        label: 'Invoice ID',
        sort: true,
    },
    {
        id: 'customer',
        label: 'Customer',
        sort: true,
    },
    {
        id: 'date',
        label: 'Date',
        sort: true,
    },
    {
        id: 'external_reference',
        label: 'External Reference',
        sort: true,
    },
    {
        id: 'performer',
        label: 'Performer',
        sort: true,
    },
    {
        id: 'event_date',
        label: 'Event Date',
        sort: true,
    },
    {
        id: 'amount',
        numeric: true,
        label: 'Amount',
        sort: true,
    },
    {
        id: 'fullfilment',
        label: 'Fullfillment',
        render: (row) => (
            <Typography variant="body2">
                {row.fullfilment
                    ? row.fullfilment.charAt(0).toUpperCase() + row.fullfilment.slice(1)
                    : ''}
            </Typography>
        ),
        sort: true,
    },
    {
        id: 'status',
        label: 'Status',
        render: (row) => (
            <Typography variant="body2">
                {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : ''}
            </Typography>
        ),
        sort: true,
    },
];

export { watchlistTableHeaders };
